import { IAttachedOption } from '../models/attached-option';
import { IProductFilter } from '../models/product-filter';
import { IProductFilterGroup } from '../models/product-filter-group';

export const buildFilterQuery = (groups: IProductFilterGroup[] = [], selectedFilters: string[] = [], preFilter = ''): string => {
  let query = '';
  let filterGroupQuery = '';

  for (const group of groups) {
    const groupFilters: IProductFilter[] = group.filters;
    const selectedGroupFilters: IProductFilter[] = groupFilters.filter(
      (loopFilter: IProductFilter): boolean => selectedFilters.indexOf(loopFilter.id) > -1,
    );

    filterGroupQuery = '';
    selectedGroupFilters.forEach((filter: IProductFilter) => {
      let filterQuery = '';

      filter.attachedOptions.forEach((filterOption: IAttachedOption) => {
        filterQuery += filterQuery === '' ? '' : ' and ';
        filterQuery += "attributes/any(a: a eq '" + filterOption.key + '|' + filterOption.value + "')";
      });

      filterGroupQuery += (filterGroupQuery === '' ? '' : ' or ') + filterQuery;
    });

    if (filterGroupQuery === '') {
      continue;
    }

    if (query === '') {
      if (selectedGroupFilters.length === 1) {
        query += filterGroupQuery;
      } else {
        query += '(' + filterGroupQuery + ')';
      }
    } else {
      query += ' and (' + filterGroupQuery + ')';
    }
  }

  if (preFilter !== '' && query !== '') {
    query = `${preFilter} and ${query}`;
  } else if (preFilter !== '' && query === '') {
    query = preFilter;
  }

  return query || '';
};
